import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/kubernetes/clusters/prometheus-raw-metrics', () => {
    return HttpResponse.json([]);
  }),
  http.get('/api/v1/kubernetes/clusters/:clusterId/dashboard-metrics', () => {
    return HttpResponse.json([]);
  }),
  http.get(
    '/api/v1/kubernetes/clusters/:clusterId/dashboard-metrics/cpu-usage',
    () => {
      return HttpResponse.json([]);
    }
  ),
  http.get(
    '/api/v1/kubernetes/clusters/:clusterId/dashboard-metrics/memory-usage',
    () => {
      return HttpResponse.json([]);
    }
  ),
];

export default handlers;
